const $inject = [];

const priceWithOperatorFilter = () => {
  return (amount, fractionSize = 0) => {
    const append = amount < 0 ? '-' : '+';
    const price = amount.toFixed(fractionSize);

    return `${append}${price}`;
  }
};

priceWithOperatorFilter.$inject = $inject;

export default priceWithOperatorFilter;



// WEBPACK FOOTER //
// ./src/filters/priceWithOperatorFilter.js